import styled from 'styled-components';

import Skeleton from '@/components/atom/Skeleton';

const DoctorItemSkeleton = () => {
  return (
    <Wrapper>
      <Left>
        <Skeleton style={{ width: 56, height: 56, borderRadius: 100 }} />
      </Left>
      <Right>
        <Skeleton style={{ width: '25%', height: 20, marginBottom: 4 }} />
        <Skeleton style={{ width: '50%', height: 18, marginBottom: 4 }} />
        <Row>
          <Skeleton style={{ width: '20%', height: 18, marginRight: 6 }} />
          <Skeleton style={{ width: '20%', height: 18 }} />
        </Row>
      </Right>
    </Wrapper>
  );
};

const DoctorSkeleton = () => {
  return (
    <div>
      {Array.from({ length: 8 }).map((_, i) => (
        <DoctorItemSkeleton key={`skeleton_${i}`} />
      ))}
    </div>
  );
};

export default DoctorSkeleton;

const Wrapper = styled.div`
  padding: 20px 24px;
  display: flex;
  width: 100%;
`;

const Left = styled.div`
  margin-right: 16px;
`;

const Row = styled.div`
  display: flex;
`;

const Right = styled.div`
  width: 100%;
`;
